module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', [_c('div', {
    staticClass: "item"
  }, [_vm._v("设备编号：" + _vm._s(_vm.device.id))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("设备类型：" + _vm._s(_vm.device.typeName))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("门店名称：" + _vm._s(_vm.device.shopName))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("设备状态：" + _vm._s(_vm.device.status == 0 ? "离线" : _vm.device.status == 1 ? "在线" : _vm.device.status))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("\n        选择套餐：\n        "), _vm._l((_vm.device.packageList), function(item) {
    return _c('el-radio', {
      key: item.id,
      staticClass: "item-radio",
      attrs: {
        "label": item.id
      },
      model: {
        value: (_vm.device.packageId),
        callback: function($$v) {
          _vm.$set(_vm.device, "packageId", $$v)
        },
        expression: "device.packageId"
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "item center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.start
    }
  }, [_vm._v("提交订单")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50a46be5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/client/index.vue
// module id = 1147
// module chunks = 2